'use strict';

/* This component pulls content from Contentful and injects the content into the
markup for the Terms and Conditions and Privacy Policy Pages. */

function LegalContent() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;
  this.extends = [];
  this.set = true;

  this.el = {};
  this._classes = {
    heading: '.js--legal-headline',
    body: '.js--legal-copy',
    updated: '.js--legal-updated'
  };

  this.init = function () {
    // Set up elements
    this.$node = $(this.node);
    this.el.heading = this.$node.find(this._classes.heading);
    this.el.body = this.$node.find(this._classes.body);
    this.el.updated = this.$node.find(this._classes.updated);

    // Create promises so both ajax requests can happen at once
    this.contentfulPromise = $.Deferred();
    this.markedPromise = this.loadMarked();

    this._loadContentful();

    // Call _onLoadContentful once the Promises have resolved
    $.when(this.contentfulPromise, this.markedPromise).then(this._onLoadContentful.bind(this));
  };

  this.initAllReady = function () {};

  this.loadMarked = function () {
    if (typeof List === 'undefined') {
      return $.ajax({
        url: '/javascripts/marked.min.js',
        dataType: 'script',
        cache: true
      });
    }
  };

  this._loadContentful = function () {
    this._contentful = new Contentful(_ContentfulConfiguration, ContentfulSpaceParams);
    this._contentful.getResource('ENTRY', { entry_id: this.set }, this.contentfulPromise.resolve.bind(this));
  };

  this._onLoadContentful = function (contentfulData) {
    var _this = this;

    this.contentfulData = contentfulData.items[0];

    // Inject header content markup
    var pageHeader = this.contentfulData.header;
    this.el.heading.text(pageHeader);

    if (this.contentfulData.subheader) {
      var pageUpdated = this.contentfulData.subheader;
      this.el.updated.text(pageUpdated);
    }

    // Inject body content markup
    if (this.contentfulData.bodyContent) {
      var pageContent = marked(this.contentfulData.bodyContent, { breaks: true });
      this.el.body.append(pageContent);
    }

    // Inject related entries into body content markup if they exist
    if (this.contentfulData.relatedContentEntries) {
      // var relatedEntries = this.contentfulData.relatedContentEntries[0].childContentEntries;
      var relatedEntries = this.contentfulData.relatedContentEntries.filter(function (entry) {
        return entry._contentType.sys.id != 'pageSectionMedia';
      });
      relatedEntries.forEach(function (item) {
        if (item.header) {
          _this.el.body.append('<h2 class="marketing-legal-template__section-heading">' + item.header + '</h2>');
        }

        if (item.bodyContent) {
          _this.el.body.append(marked(item.bodyContent, { breaks: true }));
        }

        // Inject related subsections into the body content markup if they exist
        if (item.relatedContentEntries) {
          // var subsections = item.relatedContentEntries[0].childContentEntries;
          var subsections = item.relatedContentEntries.filter(function (entry) {
            return entry._contentType.sys.id != 'pageSectionMedia';
          });
          subsections.forEach(function (item) {
            _this.el.body.append('' + ('<section class="marketing-legal-template__sub-section">' + '<h3 class="marketing-legal-template__sub-section-heading">') + item.header + '</h3>' + ('<div class="marketing-legal-template__sub-section-content">' + marked(item.bodyContent, { breaks: true }) + '</div>') + '</section>');
          });
        }
      });
    }
  };
}